<template>
  <component
    :is="ctaComponents[view.docTypeName()]"
    v-if="doc.title === 'CTA'"
  />
  <component
    :is="cardComponent"
    v-else
    class="doc__item"
    :view="view.docs()"
    :doc="doc"
    :customList="view.customList"
  />
</template>

<script setup lang="ts">
import ArticleCard from '@/app/components/article/Card.vue'
import ArticleCTACard from '@/app/components/article/CTACard.vue'
import BookCard from '@/app/components/book/card/BookCard.vue'
import BookCTACard from '@/app/components/book/card/BookCTACard.vue'
import EpisodeCard from '@/app/components/podcast/card/EpisodeCard.vue'
import CollectionCard from '@/app/components/collections/card/CollectionCard.vue'
import PodcastCard from '@/app/components/podcast/card/PodcastCard.vue'
import ContinueReadingCard from '@/app/components/book/card/ContinueReadingCard.vue'
import NewReleasesCard from '@/app/components/book/card/NewReleasesCard.vue'

import { ListView } from '@/models/docs.list'
import { ListItem, ListItemType } from '@/models/interfaces'
import { computed } from 'vue'
import type { Component } from 'vue'

const props = defineProps<{
  view: ListView
  doc: ListItem
}>()

const cardComponents: Record<ListItemType, Component> = {
  book: BookCard,
  article: ArticleCard,
  podcast_episode: EpisodeCard,
  collection: CollectionCard,
  podcast: PodcastCard,
  custom_list: CollectionCard,
}

const ctaComponents = {
  book: BookCTACard,
  article: ArticleCTACard,
  // Episodes do not haveCTAs for now
  // podcast_episode: EpisodeCTACard,
}

const cardComponent = computed(() => {
  switch (props.view.customCardComponent) {
    case 'ContinueReadingCard':
      return ContinueReadingCard
    case 'NewReleasesCard':
      return NewReleasesCard
    default:
      return cardComponents[props.view.docTypeName()]
  }
})
</script>
